import { useEffect, useState } from "react";

export function useRootFontSize() {
  const [rootFontSize, setRootFontSize] = useState(16);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const fontSizeStr = window.getComputedStyle(document.documentElement).fontSize; // e.g. "16px"
      const fontSize = parseFloat(fontSizeStr);
      if (Number.isNaN(fontSize)) {
        return;
      }
      setRootFontSize(fontSize);
    });

    // Watch for changes to the root dimensions, as a proxy for font size changes
    resizeObserver.observe(document.documentElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return {
    rootFontSize,
    rootFontScale: rootFontSize / 16,
  };
}
